import { STORAGE_KEYS } from '@constants/storage';

import { DismissedComponentsStorage } from '../types';
import { getBranchSegment, ScopedStorage } from './storageSegments';

const store = new ScopedStorage<DismissedComponentsStorage>(
  STORAGE_KEYS.DISMISSED_DYNAMIC_COMPONENTS,
  {}
);

export const getDismissedStorage = (): DismissedComponentsStorage =>
  store.read(getBranchSegment());

export const isDismissed = (componentType: string, id: string): boolean => {
  const storage = getDismissedStorage();
  return (storage[componentType] ?? []).includes(id);
};

export const dismiss = (componentType: string, id: string): void => {
  const branch = getBranchSegment();
  const current = store.read(branch);
  const existing = current[componentType] ?? [];
  if (!existing.includes(id)) {
    store.write(branch, {
      ...current,
      [componentType]: [...existing, id]
    });
  }
};
